import styled from "styled-components";


const Gap = styled.div<{ size?: string; mt?: string }>`
  height: ${({ size }) => size || '0'};
  margin-top: ${({ mt }) => mt || '0'};
`;

export default Gap;